import { useInView } from 'react-intersection-observer';

const Button = ({color, text, onClick, size}) => {

  const [ref, inView, entry] = useInView({
    threshold: 0.8,
    triggerOnce: true
  });

  return (
    <button className={`btn ${color} ${size} ${inView ? "btn-view" : ""}`} onClick = {onClick} ref={ref}>
      <h1 className="white-text">{text}</h1>
    </button>
  )
}

export default Button;